module.exports = __webpack_public_path__ + "static/media/travel6.cf0c6e73.jpg";